import script from "./ExamResultQuestionGroupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamResultQuestionGroupList.vue?vue&type=script&setup=true&lang=ts"

import "./ExamResultQuestionGroupList.vue?vue&type=style&index=0&id=a0757a8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0757a8e"]])

export default __exports__